import React, { useEffect, useState } from 'react';
import '../assets/css/service.css';
import '../assets/css/custom.css';
import bgImage from '../assets/Images/homeBackgroundImg.png';

import API_BASE_URL from "../../helper";
function Service() {

    const [services, setSevices] = useState([]);
    
    // Fetch All Works
    const fetchAllservices = async () => {
        try {
        const response = await fetch(`${API_BASE_URL}/api/service/all`);
        const data = await response.json();
        setSevices(data);
        } catch (error) {
        console.error("Failed to load Services", error);
        }
    };  

    useEffect(() => {
        fetchAllservices();
    }, []);
  return (
  <div>
    <div id="service-hero-section" className="d-flex justify-content-center align-items-center flex-column"
      style={{background: `url(${bgImage}) center/cover no-repeat`}}>
        <h2 className="text-uppercase hero-title">Our Services</h2>
        <p className='hero-subheading'>We provide complete digital solutions from websites to mobile apps and software.</p>
    </div>

    <section id='services' className='mt-5'>
        <div className='container'>
            <div className='row justify-content-center mb-4'>
                <div className='col-md-8'>
                <h2 className='text-center'>Our Best Services</h2>
                <p className='text-center'>We specialize in providing customized software development services for startups, small to mid-size and enterprise size businesses..</p>
                </div>
            </div>

            <div className='row'> 
                {services.length > 0 ? (
                services.map((service) => (
                    <div className='col-md-4 mb-4' key={service.id}>
                    <div className='serviceDiv'>
                        <div className='text-center mb-2'>
                        <img className='workImg' src={`${API_BASE_URL}/assets/Images/${service.image}`} alt="loading" />
                        </div>
                        <div className='text-center'>
                        <h5 className='text-uppercase'>{service.name}</h5>
                        <p>{service.description}</p>
                        </div>
                    </div>
                    </div> 
                ))
                ) : (
                <p>No Services Available</p>
                )} 
            </div>

        </div>
    </section>
  </div>
  )
}

export default Service;